import React, { useState } from 'react';
import { Box } from '@mui/material';
import { PillSelector } from '../PillSelector/PillSelector';
import { EMAIL_TYPE } from '../../data/forms/project.data';

export interface IAvatarSelection {
    onChange: (type: string[]) => void;
}

const SelectEmailType: React.FC<IAvatarSelection> = ({ onChange }) => {
    const [emailType, setEmailType] = useState<string[]>([]);
    const emailTitle = EMAIL_TYPE.map(email => email.title);
    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: {
                        sx: 'column',
                        lg: 'row',
                        sm: 'row',
                        xs: 'column',
                    },
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                }}>
                <Box
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                        height: 'fit-content',
                        width: '100%',
                    }}>
                    <PillSelector
                        label="Select Email Type *"
                        options={emailTitle}
                        value={emailType}
                        maxSelection={1}
                        onChange={selections => {
                            setEmailType(selections);
                            onChange && onChange(selections);
                        }}
                    />
                </Box>
            </Box>
        </>
    );
};

export { SelectEmailType };
